<template>
  <div id="toolbar">
    <div class="logo" title="Infobits 2.6">INFOBITS 2</div>
    <div id="create-panel">
      <span :class="['type-box', 'hoverable', {'disabled': !user}]" :title="'Create ' + typeDef.name"
          v-for="(typeDef, type) in typeDefs" @click="newInfobit(type)">
        <span :class="['fa', iconClass(type)]"></span>
        <span class="type-name">{{typeDef.name}}</span>
      </span>
    </div>
    <div id="help" class="hoverable">
      <span class="fa fa-question-circle-o"></span>
      <a href="../../static/help.html" target="_blank">Help</a>
    </div>
    <div id="login-state">
      <template v-if="user">
        Logged in as <b>{{user}}</b><br>
        <span class="link hoverable" @click="logout">Logout</span>
      </template>
      <span v-else class="link hoverable" @click="login">Login</span>
    </div>
    <div id="legal">
      <a href="https://nosconte.com/impressum.html"   class="hoverable" target="_blank">Impressum</a><br>
      <a href="https://nosconte.com/datenschutz.html" class="hoverable" target="_blank">Privacy</a>
    </div>
  </div>
</template>

<script>
import http from 'axios'

export default {

  computed: {

    user () {
      return this.$store.state.user
    },

    typeDefs () {
      return this.$store.state.typeDefs
    }
  },

  methods: {

    iconClass (type) {
      return 'fa-' + this.typeDefs[type].icon
    },

    newInfobit (type) {
      this.$store.dispatch('newInfobit', type)
    },

    login () {
      this.$router.push('/login')
    },

    logout () {
      http.post('/accesscontrol/logout')
      this.$store.dispatch('logout')
    }
  }
}
</script>

<style>
#toolbar {
  flex: none;
  display: flex;
  align-items: center;
  height: 38px;
  background-color: var(--toolbar-color);
  color: var(--toolbar-text-color);
  padding-left:  var(--horizontal-panel-padding);
  padding-right: var(--horizontal-panel-padding);
}

#toolbar .logo {
  color: #f8f8f8;
  font-family: var(--logo-font-family);
}

#toolbar #create-panel {
  flex: auto;
  margin-left: 3em;
}

#toolbar #create-panel .type-box {
  margin-left: 2em;
}

#toolbar #create-panel .type-box.disabled {
  pointer-events: none;
}

#toolbar #create-panel .type-box .type-name {
  margin-left: 0.2em;
}

#toolbar #login-state {
  font-size: var(--small-font-size);
  line-height: 1.4em;
  margin-right: 28px;
}

#toolbar #login-state .link {
  text-decoration: underline;
}

#toolbar #help {
  margin-right: 28px;
}

#toolbar #help a {
  text-decoration: none;
  color: inherit;
}

#toolbar #legal a {
  font-size: var(--small-font-size);
  line-height: 1.4em;
  color: inherit;
}
</style>



// WEBPACK FOOTER //
// toolbar.vue?34ff13bc